// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"lR-z","categoryName":"mR-z","categoryNameSearchHeader":"nR-z","categoryContent":"oR-z","bottomAligned":"pR-z","image":"qR-z","imageNoBackground":"rR-z"};